import * as fromDatatype from '../datatype-library';

export interface bl_wf_issue_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_src_channel: fromDatatype.VarcharDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.TextDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_tenant: fromDatatype.GuidDataFieldInterface;
}

export class bl_wf_issue_line_RowClass implements bl_wf_issue_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_src_channel: fromDatatype.VarcharDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.TextDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_tenant: fromDatatype.GuidDataFieldInterface;
}
